import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import lang from '@/lang'
import ButtonSquare, { VARIANTS } from '@/modules/base/components/buttons/square/button-square'
import ReloadIllustration from '@assets/images/reloadIllustration.png'
import { setDelayUpdateReminder } from '@/redux/ducks/global'
import { useOpenModal } from '@/modules/_helpers/openModal'

const initialAppVersion = ENV.version || '1.0.0'
const RETRY_INTERVAL_NEW_VERSION_AVAILABLE = 5 * 60 * 1000

const UpdateReminder = () => {
  const { apiVersion, delayUpdateReminder } = useSelector(state => state.global)
  const dispatch = useDispatch()
  const openModal = useOpenModal()

  const onConfirm = (cb) => {
    try {
      location.reload(true)
    } catch {
      onClose(cb)
    }
  }

  const onClose = (cb) => {
    dispatch(setDelayUpdateReminder(true))
    setTimeout(() => {
      dispatch(setDelayUpdateReminder(false))
    }, RETRY_INTERVAL_NEW_VERSION_AVAILABLE)
    cb && cb()
  }

  useEffect(() => {
    if (initialAppVersion !== apiVersion && !delayUpdateReminder) {
      openModal(close => ({
        component: 'ModalBig',
        props: {
          disableEscapeKeyDown: true,
          disableBackdropClick: true,
          title: lang.appUpdateModal.title,
          actions: [
            <div style={{ marginBottom: -20 + 'px' }}>
              <ButtonSquare
                onClick={() => onConfirm(close)}
                label={lang.appUpdateModal.buttonReloadLabel}
                variant={VARIANTS.small}
              />
            </div>,
            <div style={{ marginBottom: -20 + 'px' }}>
              <ButtonSquare
                onClick={() => onClose(close)}
                label={lang.appUpdateModal.buttonPostponeLabel}
                variant={VARIANTS.small}
              />
            </div>,
          ],
        },
        children: [
          <div key='appUpdateModalContent'>
            <p style={{ marginTop: 0, marginBottom: 30 + 'px' }}>{lang.appUpdateModal.description}</p>
            <img src={ReloadIllustration} />
          </div>,
        ],
      }))

    }
  }, [apiVersion, delayUpdateReminder])

  return (
    <></>
  )
}
export default UpdateReminder
